import { memoizeWith } from 'ramda';
import { inRange } from '@cian/newbuilding-utils';

export const inRangeMemo = memoizeWith((min, max) => `${min}${max}`, inRange);
